import { useState, useEffect, useCallback } from 'react';
import QueueService from 'views/Queue/service/index.js';

/**
 * @typedef {Object} Queue
 * @property {number} id
 * @property {number} timeout
 * @property {string|null} musiconhold
 * @property {number} wrapuptime
 * @property {boolean} autopause
 * @property {boolean} ringinuse
 * @property {string} strategy
 * @property {string} name
 * @property {string|null} periodic_announce
 * @property {number} periodic_announce_frequency
 * @property {boolean} fila_personalizada
 * @property {string|null} foraHorario
 * @property {boolean} disable
 * @property {number|null} announceFrequency
 * @property {number|null} announcePosition
 * @property {string} closing_message
 * @property {boolean} closing_message_enabled
 * @property {string} greeting_message
 * @property {boolean} greeting_message_enabled
 * @property {string} transfer_message
 * @property {boolean} transfer_message_enabled
 * @property {boolean} send_attendant_name
 * @property {string} strategy_chat
 * @property {number} max_chat_per_user
 * @property {string|null} chat_overflow
 * @property {string|null} queue_of_chat_overflow
 * @property {string} message_of_chat_overflow
 * @property {boolean} active_chat_in_chat_distribution
 * @property {number} scheduleTime_id
 * @property {number} centrodecustoId
 * @property {number|null} callback_id
 * @property {string} color
 * @property {boolean} is_chat
 * @property {boolean} is_telephony
 * @property {number} levelOfService
 * @property {Object} centrodecusto
 * @property {number} centrodecusto.id
 * @property {string} centrodecusto.name
 * @property {string} centrodecusto.description
 */

/**
 * Hook para buscar todas as filas existentes, de chat e de telefonia. 
 * É possível escolher entre mostrar ou esconder as filas desabilitadas e entre quais filas receber (chat, telefonia ou ambas).
 * Por padrão, retorna todos os tipos de fila.
 * @param {Object} [props={}]
 * @param {boolean} [props.showDisabled=false] 
 * @param {("is_chat" |  "is_telephony")[]} [props.types=["is_chat", "is_telephony"]] - quais filas devem ser retornadas (escrever o nome da propriedade) 
 * @returns 
 */
const useQueues = (props = {}) => {
  const { showDisabled = false, types = ["is_chat", "is_telephony"] } = props;

  const [state, setState] = useState({
    /** @type {Queue[]} */
    response: [],
    isLoading: false,
    isError: false,
    error: null,
  });

  const fetch = useCallback(async () => {
    setState((prevState) => ({ ...prevState, isLoading: true, isError: false, error: null }));

    try {
      const response = await QueueService.getAll();
      /** @type {Queue[]} */
      const data = response?.data?.data ?? []
      const filteredData = data.filter(queue => types.some(type => queue[type]))

      setState((prevState) => ({ ...prevState, response: filteredData, isError: false, error: null }));
    } catch (err) {
      setState((prevState) => ({ ...prevState, response: [], isError: true, error: err }));
    }
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch, showDisabled]);

  return { ...state, fetch };
};

export default useQueues;